'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MLSUserPreference = exports.MLSStats = exports.MLSGeography = exports.MLSCount = exports.MLSMedia = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactOdata = require('react-odata');

var _reactOdata2 = _interopRequireDefault(_reactOdata);

require('whatwg-fetch');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var dbase = 'http://api1.mlslistings.com/resodata';
//enable for QA environment
//const statsbase = 'http://RETSAPI.qa.mlslistings.com';
var statsbase = 'https://aculist-widget-api.azureedge.net';

var MLSCount = function (_Component) {
  _inherits(MLSCount, _Component);

  function MLSCount() {
    _classCallCheck(this, MLSCount);

    return _possibleConstructorReturn(this, (MLSCount.__proto__ || Object.getPrototypeOf(MLSCount)).apply(this, arguments));
  }

  _createClass(MLSCount, [{
    key: 'render',
    value: function render() {
      var query = this.props.query;

      var countQuery = _extends({
        top: 0,
        count: true
      }, query);
      return _react2.default.createElement(MLSData, _extends({}, this.props, { query: countQuery }));
    }
  }]);

  return MLSCount;
}(_react.Component);

var MLSMedia = function (_Component2) {
  _inherits(MLSMedia, _Component2);

  function MLSMedia() {
    _classCallCheck(this, MLSMedia);

    return _possibleConstructorReturn(this, (MLSMedia.__proto__ || Object.getPrototypeOf(MLSMedia)).apply(this, arguments));
  }

  _createClass(MLSMedia, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$resource = _props.resource,
          resource = _props$resource === undefined ? "public" : _props$resource,
          _props$collection = _props.collection,
          collection = _props$collection === undefined ? "Media" : _props$collection,
          _props$ListingKeyNume = _props.ListingKeyNumeric,
          ListingKeyNumeric = _props$ListingKeyNume === undefined ? false : _props$ListingKeyNume,
          _props$MemberKeyNumer = _props.MemberKeyNumeric,
          MemberKeyNumeric = _props$MemberKeyNumer === undefined ? false : _props$MemberKeyNumer,
          _props$MediaType = _props.MediaType,
          MediaType = _props$MediaType === undefined ? 'Photo' : _props$MediaType;

      var ResourceRecordKeyNumeric = ListingKeyNumeric ? ListingKeyNumeric : MemberKeyNumeric;
      var mediaQuery = {
        filter: {
          and: [{ ResourceRecordKeyNumeric: ResourceRecordKeyNumeric }, "MediaStatus eq ResourceEnums.MediaStatus'Valid'", 'MediaCategory eq ResourceEnums.MediaCategory\'' + MediaType + '\'']
        },
        top: 1
      };
      return _react2.default.createElement(MLSData, _extends({}, this.props, { resource: resource, collection: collection, query: mediaQuery, processed: true }));
    }
  }]);

  return MLSMedia;
}(_react.Component);

//Adding classes to accommodate stats,geographies, and UserPreferences


var MLSGeography = function (_Component3) {
  _inherits(MLSGeography, _Component3);

  function MLSGeography() {
    _classCallCheck(this, MLSGeography);

    return _possibleConstructorReturn(this, (MLSGeography.__proto__ || Object.getPrototypeOf(MLSGeography)).apply(this, arguments));
  }

  _createClass(MLSGeography, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          _props2$resource = _props2.resource,
          resource = _props2$resource === undefined ? "BiEntity" : _props2$resource,
          _props2$collection = _props2.collection,
          collection = _props2$collection === undefined ? "vGeographyByGeographyTypes" : _props2$collection,
          _props2$filter = _props2.filter,
          filter = _props2$filter === undefined ? "" : _props2$filter,
          _props2$select = _props2.select,
          select = _props2$select === undefined ? "" : _props2$select,
          rest = _objectWithoutProperties(_props2, ['resource', 'collection', 'filter', 'select']);

      return _react2.default.createElement(MLSData, _extends({ base: statsbase, resource: resource, collection: collection, query: { select: select, filter: filter } }, rest));
    }
  }]);

  return MLSGeography;
}(_react.Component);

var MLSStats = function (_Component4) {
  _inherits(MLSStats, _Component4);

  function MLSStats() {
    _classCallCheck(this, MLSStats);

    return _possibleConstructorReturn(this, (MLSStats.__proto__ || Object.getPrototypeOf(MLSStats)).apply(this, arguments));
  }

  _createClass(MLSStats, [{
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          _props3$resource = _props3.resource,
          resource = _props3$resource === undefined ? "Growth" : _props3$resource,
          collection = _props3.collection,
          filter = _props3.filter,
          select = _props3.select,
          orderBy = _props3.orderBy;

      var actualcollection = collection.toLowerCase() === 'markettrends' || collection.toLowerCase() === 'year-to-year' ? 'MarketTrends' : collection.toLowerCase() === 'kpi' ? 'MarketTrendsLast90' : collection.toLowerCase() === 'member' || collection.toLowerCase() === 'office' ? 'AgentProduction' : collection;
      return _react2.default.createElement(MLSData, _extends({}, this.props, { base: statsbase, resource: resource, collection: actualcollection, query: { select: select, filter: filter, orderBy: orderBy } }));
    }
  }]);

  return MLSStats;
}(_react.Component);

var MLSUserPreference = function (_Component5) {
  _inherits(MLSUserPreference, _Component5);

  function MLSUserPreference() {
    _classCallCheck(this, MLSUserPreference);

    return _possibleConstructorReturn(this, (MLSUserPreference.__proto__ || Object.getPrototypeOf(MLSUserPreference)).apply(this, arguments));
  }

  _createClass(MLSUserPreference, [{
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          _props4$resource = _props4.resource,
          resource = _props4$resource === undefined ? "BiEntity" : _props4$resource,
          _props4$collection = _props4.collection,
          collection = _props4$collection === undefined ? "vWidgetAssets" : _props4$collection,
          _props4$filter = _props4.filter,
          filter = _props4$filter === undefined ? "" : _props4$filter,
          _props4$select = _props4.select,
          select = _props4$select === undefined ? "" : _props4$select,
          rest = _objectWithoutProperties(_props4, ['resource', 'collection', 'filter', 'select']);

      return _react2.default.createElement(MLSData, _extends({ base: statsbase, resource: resource, collection: collection, query: { select: select, filter: filter } }, rest));
    }
  }]);

  return MLSUserPreference;
}(_react.Component);
//end

var MLSData = function (_Component6) {
  _inherits(MLSData, _Component6);

  function MLSData() {
    _classCallCheck(this, MLSData);

    return _possibleConstructorReturn(this, (MLSData.__proto__ || Object.getPrototypeOf(MLSData)).apply(this, arguments));
  }

  _createClass(MLSData, [{
    key: 'render',
    value: function render() {
      var _props5 = this.props,
          _props5$base = _props5.base,
          base = _props5$base === undefined ? dbase : _props5$base,
          token = _props5.token,
          collection = _props5.collection,
          _props5$authHeader = _props5.authHeader,
          authHeader = _props5$authHeader === undefined ? { headers: _extends({}, typeof this.props.token !== "undefined" && { Authorization: 'Bearer ' + this.props.token }, { 'Accept': 'application/json' }) } : _props5$authHeader,
          link = _props5.link,
          _props5$resource = _props5.resource,
          resource = _props5$resource === undefined ? 'www' : _props5$resource,
          limit = _props5.limit,
          _props5$processed = _props5.processed,
          processed = _props5$processed === undefined ? false : _props5$processed;


      if (link) {
        return _react2.default.createElement(_reactOdata2.default, _extends({}, this.props, { baseUrl: link, options: authHeader }));
      }

      if (collection.toLowerCase() === 'media' && !processed) {
        return _react2.default.createElement(MLSMedia, _extends({}, this.props, { collection: collection, resource: resource, options: authHeader }));
      }

      return _react2.default.createElement(_reactOdata2.default, _extends({}, this.props, { baseUrl: base + '/' + resource + '/' + collection, options: authHeader }));
    }
  }]);

  return MLSData;
}(_react.Component);

exports.MLSMedia = MLSMedia;
exports.MLSCount = MLSCount;
exports.MLSGeography = MLSGeography;
exports.MLSStats = MLSStats;
exports.MLSUserPreference = MLSUserPreference;
exports.default = MLSData;


//////////////////
// WEBPACK FOOTER
// ./~/react-aculistkpiwidget/lib/react-mlsdata.js
// module id = 216
// module chunks = 0